import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import _map from 'lodash/map'
import {
  INVALID_CREDENTIALS,
  INVALID_CREDENTIALS_MSG,
} from '@platform-shared/constants'
import getTime from 'date-fns/getTime'

const login = {
  props: {
    initialUsername: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: {
        username: this.initialUsername,
        password: '',
      },
      error: null,
    }
  },
  validations: {
    model: {
      username: {
        required,
        validUserNameLogin() {
          return !this.model.username.includes(' ')
        },
      },
      password: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters('member', [
      'isLoggingIn',
      'mfaType',
      'showPhaWelcome',
      'loadingFromLoginScreen',
      'showSSORegistration',
    ]),
    ...mapGetters('app', ['securityMessage', 'postLoginPath']),
    ...mapGetters('questionnaire', ['startUpQuestionnaire']),
    ...mapGetters('client', ['hasFeature', 'loginLogos', 'showLanguage']),
    formHasError() {
      return !!this.error
    },
    showVerifyMfa() {
      return !!this.mfaType
    },
  },
  methods: {
    ...mapActions('member', [
      'login',
      'getMemberInfo',
      'requestMfaCode',
      'verifyMfaCode',
      'updateMfaPreference',
    ]),
    ...mapActions('client', ['getClientConfig']),
    ...mapActions('app', ['removePostLoginPath']),
    memberInfoSuccess() {
      this.getClientConfig()
      if (this.showSSORegistration) {
        this.$router.replace('/register-sso')
      } else if (this.postLoginPath) {
        this.$router.replace(this.postLoginPath).then(this.removePostLoginPath)
      } else if (this.startUpQuestionnaire && !this.showPhaWelcome) {
        localStorage.setItem('fteViewTime', getTime(new Date()))
        this.$router.push(`/questionnaire/${this.startUpQuestionnaire.type}`)
      } else {
        this.$router.replace('/')
      }
    },
    initData() {
      this.getMemberInfo({ fromLoginScreen: true }).then(this.memberInfoSuccess)
    },
    handleLogin(onSuccess) {
      if (this.isLoggingIn) return

      this.error = null
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.login(this.model)
        .then(() => onSuccess())
        .catch((error) => {
          this.error =
            error.json.status === 'fail'
              ? _map(error.json.data, (errorItem) => errorItem).join(
                  String.fromCharCode(0x000a)
                )
              : error.json.message === INVALID_CREDENTIALS
              ? INVALID_CREDENTIALS_MSG
              : error.json.message
        })
    },
  },
}
export default login
